var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "men_6"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#876450"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.374,115.394c-4.963-9.396-36.874-15.292-36.874-15.292s-30.675,5.554-36.508,15.554 c-3.669,13.039-6.49,29.281-6.49,29.281L72.5,145h42.752C115.252,145,114.039,127.236,109.374,115.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.5,100.102c0,0,31.911,5.896,36.874,15.292c4.665,11.842,6.128,29.606,6.128,29.606H72.5 V100.102z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 81,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.375,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 81,
    style: {
      fill: "#E4B692"
    },
    width: 8.688,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.474c1.563,4.485,7.869,7.057,12.5,7.057 c1.676,0,3.306-0.281,4.875-0.795V81H63.813V94.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.838,62.653c0-18.162-10.001-28.489-22.338-28.489c-12.336,0-22.338,10.327-22.338,28.489 c0,24.429,10.002,32.886,22.338,32.886C84.837,95.539,94.838,86.063,94.838,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M91.438,75.246c-4.049-0.424-6.783-4.787-6.098-9.739c0.678-4.957,4.513-8.638,8.564-8.216 c4.047,0.422,6.776,4.783,6.093,9.739C99.318,71.988,95.487,75.665,91.438,75.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M45.161,67.031c-0.684-4.957,2.046-9.317,6.091-9.739c4.054-0.422,7.889,3.259,8.567,8.216 c0.684,4.953-2.052,9.315-6.1,9.739C49.671,75.665,45.84,71.988,45.161,67.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.838,62.653c0-18.162-10.001-28.489-22.338-28.489v61.375 C84.837,95.539,94.838,86.063,94.838,62.653z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F0F0D"
    },
    d: "M92.594,77.874c-1.201,3.378-3.234,7.44-6.907,7.44c-4.592,0-7.875-3.731-13.142-3.731 c-0.015,0-0.029,0.002-0.044,0.002c-0.016,0-0.03-0.002-0.046-0.002c-5.266,0-8.548,3.731-13.14,3.731 c-3.674,0-5.705-4.062-6.907-7.44l-1.04-6.508v7.788c0,0,1.745,9.171,5.096,11.387c2.728,2.424,11.635,6.576,15.99,6.576h0.001 c0.015,0,0.03-0.002,0.046-0.002c0.015,0,0.03,0.002,0.044,0.002h0.002c4.356,0,13.263-4.152,15.99-6.576 c3.351-2.216,5.096-11.387,5.096-11.387v-7.788L92.594,77.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0"
    },
    d: "M109.374,115.394c-2.899-5.487-14.979-9.777-24.534-12.399 c-0.374,6.499-5.747,11.658-12.34,11.658s-11.966-5.159-12.34-11.658c-9.556,2.622-21.635,6.912-24.534,12.399 C31.957,128.433,28.889,145,28.889,145H72.5h43.611C116.111,145,114.039,127.236,109.374,115.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M29.821,140.213c-0.59,2.938-0.933,4.787-0.933,4.787H72.5h43.611c0,0-0.218-1.868-0.671-4.787 H29.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M30.81,135.427h83.827c-0.273-1.504-0.586-3.117-0.938-4.787h-81.85 C31.474,132.322,31.126,133.931,30.81,135.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M32.947,125.854h79.657c-0.397-1.603-0.83-3.211-1.298-4.787h-77.19 C33.713,122.664,33.321,124.269,32.947,125.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M72.5,114.653c-3.169,0-6.049-1.2-8.234-3.16H39.364c-1.701,1.22-3.01,2.522-3.738,3.901 c-0.082,0.293-0.164,0.59-0.246,0.886h74.332c-0.111-0.298-0.224-0.595-0.338-0.886c-0.728-1.378-2.037-2.681-3.738-3.901 H80.734C78.549,113.454,75.669,114.653,72.5,114.653z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M48.757,106.706h12.209c-0.447-1.164-0.731-2.409-0.806-3.711 C56.509,103.996,52.492,105.244,48.757,106.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M84.034,106.706h12.209c-3.735-1.462-7.752-2.71-11.403-3.711 C84.765,104.298,84.481,105.542,84.034,106.706z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4E3B"
    },
    d: "M56.527,104.042c1.21,7.744,7.89,13.675,15.973,13.675s14.763-5.932,15.974-13.675 c-1.235-0.374-2.454-0.723-3.634-1.047c-0.374,6.499-5.747,11.658-12.34,11.658s-11.966-5.159-12.34-11.658 C58.98,103.319,57.762,103.668,56.527,104.042z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E44049"
    },
    d: "M92.912,59.437c0,0-7.016-10.749-19.733-10.749S51.253,59.437,51.253,59.437 c-3.29-1.897-3.726-30.139,22.583-30.139C96.233,29.298,96.421,55.643,92.912,59.437z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "68.578,36.744 66.735,36.733 65.683,38.246 65.122,36.49 63.359,35.956 64.855,34.882  64.818,33.04 66.303,34.13 68.043,33.525 67.465,35.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "78.506,37.275 77.142,36.374 75.625,36.986 76.061,35.41 75.011,34.156 76.645,34.084  77.511,32.698 78.084,34.23 79.672,34.625 78.392,35.644  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "85.597,44.367 83.811,43.936 82.441,45.165 82.298,43.332 80.706,42.41 82.405,41.707  82.791,39.909 83.984,41.308 85.813,41.119 84.851,42.687  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "73.896,43.304 72.9,42.614 71.767,43.044 72.114,41.883 71.354,40.938 72.567,40.91  73.23,39.896 73.632,41.04 74.802,41.358 73.838,42.093  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "57.763,48.267 55.502,47.939 53.948,49.617 53.563,47.364 51.487,46.406 53.508,45.343  53.778,43.073 55.415,44.667 57.658,44.222 56.647,46.272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "63.359,45.165 63.125,44.69 62.6,44.613 62.979,44.244 62.891,43.722 63.359,43.968  63.827,43.722 63.738,44.244 64.118,44.613 63.593,44.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "61.31,39.049 59.912,39.143 59.198,40.348 58.676,39.049 57.31,38.742 58.384,37.845  58.253,36.45 59.439,37.194 60.726,36.639 60.384,37.998  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "91.803,52.345 90.473,50.981 88.595,51.303 89.481,49.617 88.596,47.931 90.473,48.253  91.803,46.889 92.077,48.775 93.784,49.617 92.077,50.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBDC5F"
    },
    points: "87.37,37.275 87.55,37.905 88.171,38.115 87.627,38.479 87.62,39.135 87.105,38.731  86.479,38.926 86.704,38.311 86.325,37.777 86.979,37.801  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.834f1d725010e3108be6816afe68571a.svg";
export { ForwardRef as ReactComponent };